import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Switcher from '../../shared/Switcher';
import fixMobileSafariWhiteScreenBug from '../../utils/fixMobileSafariWhiteScreenBug';
import { getSwitcherTitle, getDescription } from './helpers';
import CourseGoogleMap from './CourseGoogleMap';

const mapWrappers = {
    containerElement: <div className="cp-courseMap__container" />,
    mapElement: <div className="cp-courseMap__map" />,
};

class CourseMap extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { selected: 0 };
    }

    setSelected = (selected) => {
        this.setState({ selected }, () => {
            fixMobileSafariWhiteScreenBug();
        });
    }

    render() {
        const { selected } = this.state;
        const { courseMap } = this.props.data;
        const titles = courseMap.map(getSwitcherTitle);
        const item = courseMap[selected];

        const {
            zoom, latitude: lat, longitude: lng,
        } = courseMap[0];
        const pos = { lat, lng };

        return (
            <section className="cp-courseMap">
                <div className="cp-courseMap__switchDescWrapper">
                    <Switcher
                        items={titles}
                        selected={selected}
                        setSelected={this.setSelected}
                    />
                    <div className="cp-courseMap__description">
                        {getDescription(item)}
                    </div>
                </div>
                {item.largeMapImagePath &&
                    <figure className="pp-figure">
                        <img
                            src={item.largeMapImagePath}
                            alt="Course Map"
                        />
                    </figure>
                }
                <CourseGoogleMap
                    defaultZoom={zoom}
                    pos={pos}
                    {...mapWrappers}
                />
            </section>
        );
    }
}

CourseMap.propTypes = {
    data: PropTypes.shape({
        courseMap: PropTypes.arrayOf(PropTypes.shape({
            raceTypeCode: PropTypes.arrayOf(PropTypes.string),
            rpDetailedAwDesc: PropTypes.string,
            rpDetailedFlatDesc: PropTypes.string,
            rpDetailedJumpDesc: PropTypes.string,
            largeMapImagePath: PropTypes.string,
            zoom: PropTypes.number,
            latitude: PropTypes.number,
            longitude: PropTypes.number,
        })),
    }).isRequired,
};

export default CourseMap;



// WEBPACK FOOTER //
// ./src/js/course/courseMap/CourseMap.jsx